import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import React, { lazy, Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import WithLoginOurService from '../pages/OurServices/WithLoginOurService';

export const Loadable = (Component) => (props) => {
    return (
        <Suspense>
            <Component {...props} />
        </Suspense>
    );
};

const Spinner = Loadable(lazy(() => import("../component/Spinner")));

const SignUp = Loadable(lazy(() => import("../pages/auth/SignUp/Signup")));
const VerificationOtp = Loadable(lazy(() => import("../pages/auth/SignUp/VerificationOtp")));
const ChangePassword = Loadable(lazy(() => import("../pages/auth/ChangePassword/ChangePaawsord")));
const ForgetPassword = Loadable(lazy(() => import("../pages/auth/ForgetPassword/ForgetPassword")));
const ResetNewPassword = Loadable(lazy(() => import("../pages/auth/ForgetPassword/SetNewPassword")));
const EditProfile = Loadable(lazy(() => import("../pages/auth/EditProfile/EditProfile")));
const CompleteProfile = Loadable(lazy(() => import("../pages/auth/Home/CompleteProfile.js/CompleteProfile")));
const Login = Loadable(lazy(() => import("../pages/auth/SignUp/Login/Login")));
const Home = Loadable(lazy(() => import("../pages/auth/Home")));
const HomewithLogin = Loadable(lazy(() => import("../pages/auth/Home/HomewithLogin")));

const AboutUsWithLogin = Loadable(lazy(() => import("../pages/auth/AboutUs/WithLoginAbout")));
const ContactUs = Loadable(lazy(() => import("../pages/Cms/ContactUs/ContactUs")));
const ContactUsWithLogin = Loadable(lazy(() => import("../pages/Cms/ContactUs/WithLoginContactUs")));
const Subscription = Loadable(lazy(() => import("../pages/Subscriptions/Subscriptions")));
const PaymentSuccessSubscription = Loadable(lazy(() => import("../pages/Subscriptions/PaymentSuccessSubscription")));

const SubscriptionWithLogin = Loadable(lazy(() => import("../pages/Subscriptions/WithLoginSubscripton")));
const OurServices = Loadable(lazy(() => import("../pages/OurServices/OurServices")));
const ViewEstimatorReview = Loadable(lazy(() => import("../pages/OurServices/Estimatorview")));
const OurServicesWithLogin = Loadable(lazy(() => import("../pages/OurServices/WithLoginOurService")));

const MyEstimator = Loadable(lazy(() => import("../pages/MyestimatorHomeOwner/MyestimatorHomeOwner")));

const HomeOwnerServices = Loadable(lazy(() => import("../pages/MyestimatorHomeOwner/HomeOwnerServices")));
const MyestimatorHomeOwner = Loadable(lazy(() => import("../pages/MyEstimator/withLoginMysEstimator")));
const Privacy_Policy = Loadable(lazy(() => import("../pages/Cms/Privacy&Policy/Privacy_Policy")));
const Privacy_PolicywithLOgin = Loadable(lazy(() => import("../pages/Cms/Privacy&Policy/WithLogin_p_policy")));
const Terms_Condition = Loadable(lazy(() => import("../pages/Cms/Terms&Condition/Terms_condition")));
const Terms_Conditionwithlogin = Loadable(lazy(() => import("../pages/Cms/Terms&Condition/Withlogin_tc")));
const Faqs = Loadable(lazy(() => import("../pages/Cms/Faq/Faq")));
const Faqwithlogin = Loadable(lazy(() => import("../pages/Cms/Faq/WithLoginFaq")));
const PaymentPage = Loadable(lazy(() => import("../pages/Payment/Payment")));

const NotificationPage = Loadable(lazy(() => import("../pages/Notification/Notification")));
const PageNotFound = Loadable(lazy(() => import("./PageNotFound")));


const Router = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const islogin = localStorage.getItem("PisLogin") === 'true';
    const token = localStorage.getItem("Ptoken");

    const sharedRoutes = [
        { path: "/", element: <HomewithLogin /> },
        { path: "/Home", element: <HomewithLogin /> },
        { path: "/terms_condition", element: <Terms_Conditionwithlogin /> },
        { path: "/privacy_policy", element: <Privacy_PolicywithLOgin /> },
        { path: "*", element: <PageNotFound /> },
        { path: "/faq", element: <Faqwithlogin /> },
        { path: "/about-us", element: <AboutUsWithLogin /> },
        { path: "/contact-us", element: <ContactUsWithLogin /> },
        { path: "/our-services", element: <OurServices /> }
    ];

    // Routes for Non-Logged-In Users
    const guestRoutes = [
        { path: "/login", element: <Login /> },
        { path: "/signup", element: <SignUp /> },
        { path: "/complete_profile", element: <CompleteProfile /> },
        { path: "/forget-password", element: <ForgetPassword /> },
        { path: "/reset-new-password", element: <ResetNewPassword /> },
        { path: "/otp-verification", element: <VerificationOtp /> },
        { path: "/subscription", element: <Subscription /> }
    ];

    // Routes for Logged-In Users
    const protectedRoutes = [
        { path: "/edit-profile", element: <EditProfile /> },
        { path: "/change-password", element: <ChangePassword /> },
        { path: "/withlogin-subscription", element: <SubscriptionWithLogin /> },
        { path: "/withlogin-our-services", element: <WithLoginOurService /> },
        { path: "/my-estimator", element: <MyEstimator /> },
        { path: "/user-notification", element: <NotificationPage /> },
        { path: "/view-estimator-review", element: <ViewEstimatorReview /> },
        { path: "/payment_page", element: <PaymentPage /> },
        { path: "/view-estimator-review", element: <ViewEstimatorReview /> },
        { path: "/home_owner_our-services", element: <HomeOwnerServices /> },
        { path: "/home_owner_estimate", element: <MyestimatorHomeOwner /> },
        { path: "/payment-success-subscription", element: <PaymentSuccessSubscription /> }
    ];

    useEffect(() => {
        const privateRoutes = protectedRoutes.map(route => route.path);
        const publicRoutes = guestRoutes.map(route => route.path);

        // Check if the current path is a private or public route
        const isPrivateRoute = privateRoutes.includes(location.pathname);
        const isPublicRoute = publicRoutes.includes(location.pathname);

        if (!islogin && isPrivateRoute) {
            navigate('/login');
        } else if (islogin && isPublicRoute) {
            navigate('/');
        }

    }, [islogin, location.pathname, token]);

    const isLoading = useSelector((state) => state.MasterSlice.isLoading);


    // Combine Routes Based on Login Status
    const routes = islogin
        ? [...sharedRoutes, ...protectedRoutes]
        : [...sharedRoutes, ...guestRoutes];

    return (
        <>
            <Spinner isActive={isLoading} message={'Please Wait...'} />
            <Routes>
                {routes.map(({ path, element }, index) => (
                    <Route key={index} path={path} element={element} />
                ))}
            </Routes>
        </>
    );


    if (!islogin) {
        return (
            <>
                <Spinner isActive={isLoading} message={'Please Wait...'} />
                <Routes>
                    <Route path="/" element={<HomewithLogin />} />
                    <Route path="/Home" element={<HomewithLogin />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/complete_profile" element={<CompleteProfile />} />
                    <Route path="/terms_condition" element={<Terms_Conditionwithlogin />} />
                    <Route path="/faqs" element={<Faqs />} />

                    <Route path="/forget-password" element={<ForgetPassword />} />

                    <Route path="/reset-new-password" element={<ResetNewPassword />} />

                    <Route path="/otp-verification" element={<VerificationOtp />} />
                    <Route path="/privacy_policy" element={<Privacy_PolicywithLOgin />} />
                    <Route path="/faq" element={<Faqwithlogin />} />
                    <Route path='/about-us' element={<AboutUsWithLogin />} />
                    <Route path='/contact-us' element={<ContactUsWithLogin />} />


                    <Route path='/subscription' element={<Subscription />} />


                    <Route path='/our-services' element={<OurServices />} />
                    <Route path="*" element={<PageNotFound />} />


                </Routes>
            </>)
    } else {
        return (
            <>
                <Spinner isActive={isLoading} message={'Please Wait...'} />
                <Routes>
                    <Route path="/" element={<HomewithLogin />} />
                    <Route path="/Home" element={<HomewithLogin />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/complete_profile" element={<CompleteProfile />} />

                    <Route path="/terms_condition" element={<Terms_Conditionwithlogin />} />

                    <Route path="/privacy_policy" element={<Privacy_PolicywithLOgin />} />
                    <Route path="/faq" element={<Faqwithlogin />} />
                    <Route path='/about-us' element={<AboutUsWithLogin />} />

                    <Route path="/change-password" element={<ChangePassword />} />
                    <Route path="/forget-password" element={<ForgetPassword />} />
                    <Route path="/reset-new-password" element={<ResetNewPassword />} />
                    <Route path="/edit-profile" element={<EditProfile />} />
                    <Route path="/otp-verification" element={<VerificationOtp />} />
                    <Route path='/contact-us' element={<ContactUsWithLogin />} />

                    <Route path='/subscription' element={<Subscription />} />
                    <Route path='/withlogin-subscription' element={<SubscriptionWithLogin />} />

                    <Route path='/payment-success-subscription' element={<PaymentSuccessSubscription />} />

                    <Route path='/our-services' element={<OurServices />} />
                    <Route path='/home_owner_our-services' element={<HomeOwnerServices />} />
                    <Route path='/home_owner_estimate' element={<MyestimatorHomeOwner />} />

                    <Route path='/withlogin-our-services' element={<OurServicesWithLogin />} />
                    <Route path='/view-estimator-review' element={<ViewEstimatorReview />} />
                    <Route path='/my-estimator' element={<MyEstimator />} />
                    <Route path='/user-notification' element={<NotificationPage />} />

                    <Route path='/payment_page' element={<PaymentPage />} />
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </>
        )
    }

}

export default Router;
